<script>
  import { fade } from 'svelte/transition'
  import Lenke from '../lenke/lenke.svelte'
  import { landingsside } from '../../stores/landingsside'

  $: lenke = $landingsside.topplenker[0]

  let topplenke = true
</script>

<div data-ec-list="topplenke" in:fade={{ duration: 300 }} out:fade={{ duration: 200 }}>
  <Lenke {lenke} {topplenke} />
</div>
